import { AfterViewInit, Component } from '@angular/core'
import { IonIcon, IonMenuToggle, IonText } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import * as Sentry from '@sentry/angular'
import { addIcons } from 'ionicons'
import { bugOutline } from 'ionicons/icons'

@Component({
	selector: 'app-sentry-feedback',
	templateUrl: './sentry-feedback.component.html',
	standalone: true,
	imports: [IonIcon, IonMenuToggle, IonText, TranslatePipe],
})
export class SentryFeedbackComponent implements AfterViewInit {
	constructor() {
		addIcons({ bugOutline })
	}

	ngAfterViewInit() {
		const feedback = Sentry.getFeedback()
		const userFeedbackButton = document.querySelector('#sentry-user-feedback')
		if (userFeedbackButton) {
			feedback?.attachTo(userFeedbackButton, {
				formTitle: 'Report a Bug!',
			})
		}
	}
}
